<span v-if="label">{{label}}</span><span v-else>&nbsp;</span>